export default "<p>home works!</p>\r\n<a routerLink=\"/app/explore\">Login</a>\r\n<a routerLink=\"/app/explore\">Register</a>"